import * as React from 'react';
import { useClickAndDoubleClick, getDmIcon } from '@bimser/common';
import Style from '../assets/style.scss';

const ObjectItem = (props: any) => {
	const handleClick = useClickAndDoubleClick({
		params: props.data,
		clickF: props.handleFolderItemSelected,
		doubleClickF: props.handleFolderItemDoubleClick
	});

	return (
		<div
			className={[
				Style.noselect,
				Style.ObjectItem,
				props.selected ? Style.ObjectItemSelected : ''
			].join(' ')}
			onClick={handleClick}
		>
			{getDmIcon(props.data.type, undefined, props.data.name)}
			<span className={Style.noselect}>{props.data.name}</span>
		</div>
	);
};

export default ObjectItem;
